var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid page__container page-section"},[_c('div',{staticClass:"row"},[_c('StaffStatsTable',{attrs:{"className":"col-lg-12"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }